/**
 * OptionsEditor — the multiple-choice answer options for a must-ask question.
 * Each option is a {label, value} row (label = what the user sees, value = what
 * is sent back). Add / remove / reorder. Controlled by the parent.
 */
import { moveItem, newOption } from './flowModel.js'
import { RowControls } from './RowControls.jsx'

export function OptionsEditor({ options, onChange }) {
  const update = (i, patch) =>
    onChange(options.map((o, idx) => (idx === i ? { ...o, ...patch } : o)))

  return (
    <div className="admin-flow-options">
      <div className="admin-flow-options__label">Options</div>
      {options.length === 0 && (
        <p className="admin-aim-empty admin-flow-empty">
          No options — the user answers freeform.
        </p>
      )}
      <ul className="admin-flow-list" role="list">
        {options.map((o, i) => (
          <li key={o.id} className="admin-flow-opt-row">
            <input
              className="admin-aim-input"
              type="text"
              placeholder="Label (shown)"
              value={o.label}
              aria-label={`Option ${i + 1} label`}
              onInput={(e) => update(i, { label: e.currentTarget.value })}
            />
            <input
              className="admin-aim-input"
              type="text"
              placeholder="Value (sent)"
              value={o.value}
              aria-label={`Option ${i + 1} value`}
              onInput={(e) => update(i, { value: e.currentTarget.value })}
            />
            <RowControls
              index={i}
              count={options.length}
              label={`option ${i + 1}`}
              onMove={(d) => onChange(moveItem(options, i, d))}
              onRemove={() => onChange(options.filter((_, idx) => idx !== i))}
            />
          </li>
        ))}
      </ul>
      <button
        type="button"
        className="admin-ai-btn admin-ai-btn--ghost admin-flow-add"
        onClick={() => onChange([...options, newOption()])}
      >
        + Add option
      </button>
    </div>
  )
}
